import { createSelector } from "reselect";

// import { getActionMetadata } from "../../utils/CreativeActions";

function getSelectedCreatives(state) {
	let selectedIds = state.selected?.creatives;
	let { items } = state.creatives;

	return {
		selectedIds,
		items,
	};
}

function getSelectedVersions(state) {
	let selectedIds = state.selected?.versions;
	let { items } = state.creativeVersions;

	return {
		selectedIds,
		items,
	};
}

function areAllSelected({ selectedIds = [], items }) {
	if (!items || items.length === 0) {
		return false;
	}
	let selectedIdSet = new Set(selectedIds);
	return items.every(item => selectedIdSet.has(item.id));
}


function buildCreativeSelectedItems({ selectedIds = [], items }) {
	let  selectedItems = [];

	selectedIds.forEach((id)=> {
		const creative = items.find(creative => creative.id === id);

		if(creative){
			selectedItems.push({
				libraryId:     creative.creativeLibraryId,
				creativeId:    creative.id,
				creativeName:  creative.name,
				origin:        creative.origin || false,
				conceptId:     creative.conceptID || false,
				conceptName:   creative.conceptName || false,
				...creative,
			});
		}
	 });
	return selectedItems;
}

function getSelectedAssets(state) {
	const selected = state.selected?.assets;
	const { items } = state.assets;

	return {
		assets: items,
		selected,
	};
}

function checkAllAssetsSelected({ assets = [], selected = []}) {
	if (!assets || assets.length === 0) {
		return false;
	}

	return assets.length === selected.length;
}

function getSelectedPreviews(state) {
	const selectedIds = state.selected.creativePreviews;
	const { items } = state.creativePreviews;

	return {
		selectedIds,
		items,
	};
}

function buildPreviewSelectedItems({ selectedIds = [], items }) {
	let selectedItems = [];

	selectedIds.forEach((id) => {
		const preview = items.find(preview => preview.id === id);
		if (preview) {
			selectedItems.push({ ...preview });
		}
	});

	return selectedItems;
}

export const selectedCreativeData = createSelector([getSelectedCreatives], buildCreativeSelectedItems);
export const areAllCreativesSelected = createSelector([getSelectedCreatives], areAllSelected);
export const areAllVersionsSelected = createSelector([getSelectedVersions], areAllSelected);
export const areAllAssetsSelected = createSelector([getSelectedAssets], checkAllAssetsSelected);
export const areAllPreviewsSelected = createSelector([getSelectedPreviews], areAllSelected);
export const selectedPreviewData = createSelector([getSelectedPreviews], buildPreviewSelectedItems);

export const PRIVATE ={
	getSelectedCreatives,
	getSelectedAssets,
	buildCreativeSelectedItems,
	areAllSelected,
	checkAllAssetsSelected,
	getSelectedPreviews,
	buildPreviewSelectedItems,
};
